import {createFeatureSelector} from '@ngrx/store';
import {ParametryKwotyDocelowej} from '../../../services/samoobsluga/types/ParametryKwotyDocelowej.interface';
import {Features} from '../../features';


export const parametryKwotyDocelowejSelector = createFeatureSelector<ParametryKwotyDocelowej>(Features.PARAMETRY_KWOTY_DOCELOWEJ);
